import React, { Suspense } from 'react'
import { colors } from '@lmc/common/constants'
import Field from '../../../fields'
import { Icon } from '../../../generic'

interface BlisterPackFieldProps {
  confirmProps: Record<string, any>
  errors: any[]
  fields: Record<string, any>
  formId: string
  onConfirm: () => void
  renderFieldTitle: (props: {
    title: string
    hasError: boolean
    note: string
    renderRight: () => React.ReactNode
  }) => React.ReactNode
  requireConfirm: boolean
  testId?: string
}

export default function BlisterPackField(
  props: BlisterPackFieldProps
): JSX.Element {
  const {
    confirmProps,
    errors,
    fields,
    formId,
    onConfirm,
    renderFieldTitle,
    requireConfirm,
    testId
  } = props

  const title = 'Part of a monitored dosage system?'
  const hasError = !!errors.length && fields.blisterPack === undefined
  const labelNote = 'For example a dosette box / blister packs'

  const selectedOptionFieldStyle = requireConfirm ? styles.prepopField : null

  const renderRight = () => {
    return (
      fields.blisterPack && (
        <Icon
          style={styles.mdsIcon}
          url="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/emar/mds-icon.png"
          data-testid={testId ? `${testId}-mds-icon` : 'mds-icon'}
        />
      )
    )
  }

  return (
    <div
      style={styles.blisterPackFieldContainer}
      data-testid={
        testId ? `${testId}-blister-pack-field` : 'blister-pack-field'
      }
    >
      <div style={styles.fieldSubContainer}>
        {renderFieldTitle &&
          renderFieldTitle({
            title,
            hasError,
            note: labelNote,
            renderRight
          })}
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            compact
            confirmProps={confirmProps}
            displayLabel={false}
            formId={formId}
            keys="blisterPack"
            label={title}
            layout="no-label"
            options={DEFAULT_RADIO_OPTIONS}
            onConfirm={onConfirm}
            requireConfirm={requireConfirm}
            required
            selectedOptionFieldStyle={selectedOptionFieldStyle}
            type="radios"
            values={fields}
            data-testid={
              testId
                ? `${testId}-blister-pack-field-input`
                : 'blister-pack-field-input'
            }
          />
        </Suspense>
      </div>
    </div>
  )
}

const DEFAULT_RADIO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
]

const styles = {
  blisterPackFieldContainer: {
    marginTop: 18
  },
  fieldSubContainer: {
    borderRadius: 15,
    padding: 16,
    marginBottom: 16,
    background: colors.white
  },
  mdsIcon: {
    height: 25
  },
  prepopField: {
    background: colors.hoverblue
  },
  userGeneratedFieldContainer: {
    marginBottom: 16
  }
}
